export const formatDisplayTS = (ts, converted) => {
  // format timestamps to mm/dd/yyyy hh:mm:ss (24hr format)

  let dateString = ''
  let date = new Date() // sidebar timestamp gets the current time

  if (converted === true) {
    // ts: 2024-01-10T17:01:15.000Z
    // ts shows UTC tz, but actually we have already converted the timestamp to user's timezone, so lets ignore the timezone of this

    dateString = ts.substring(0, 19)
    date = new Date(dateString)

  } else if (converted === false) {
    // ts: 20240113155312

    // some cameras don't have last request ts
    if (ts.length < 14) return ''

    const year = ts.substring(0, 4)
    const month = ts.substring(4, 6)
    const day = ts.substring(6, 8)
    const hours = ts.substring(8, 10)
    const minutes = ts.substring(10, 12)
    const seconds = ts.substring(12, 14)
    dateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    date = new Date(dateString)
  }

  // get user locale's date format
  const userLocale = navigator.language || navigator.userLanguage
  const formattedDate = date.toLocaleDateString(userLocale, {year: 'numeric', month: '2-digit', day: '2-digit',})
  const formattedTime = date.toLocaleTimeString(userLocale, { hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'})
  return formattedDate + ' ' + formattedTime

}